import { fetchApi } from '../client';

export interface MonthTrend {
  month: string;
  label: string;
  revenue: number;
  consultations: number;
}

export interface RevenueTrendResponse {
  months: MonthTrend[];
  forecastNextMonth: number;
  forecastLabel: string;
}

export interface DoctorEfficiencyRow {
  doctorId: string;
  doctorName: string;
  totalRevenue: number;
  consultations: number;
  revenuePerConsult: number;
}

export interface LostRevenueResponse {
  noShows: { count: number; estimatedLoss: number };
  overdueFollowUps: { count: number; estimatedLoss: number };
  unpaidBills: { count: number; totalAmount: number };
  totalEstimatedLoss: number;
  averageBillValue: number;
  periodDays: number;
}

export interface PatientCohortResponse {
  newPatients: { count: number; revenue: number };
  returningPatients: { count: number; revenue: number };
  totalRevenue: number;
  newPct: number;
  periodDays: number;
}

export interface OutstandingBill {
  billId: string;
  billNumber: string;
  patientId: string;
  patientName: string;
  billDate: string;
  daysOld: number;
  outstanding: number;
  bucket: '0-30d' | '31-60d' | '61-90d' | '90d+';
}

export interface OutstandingResponse {
  bills: OutstandingBill[];
  totalPending: number;
  agingBuckets: Record<string, number>;
}

export interface SuggestionFinding {
  ruleCode: string;
  severity: 'HIGH' | 'MODERATE' | 'LOW';
  title: string;
  message: string;
  estimatedMonthlyImpact: number;
}

export const revenueIntelligenceModule = {
  getTrend: () =>
    fetchApi<RevenueTrendResponse>('/api/analytics/revenue/trend'),

  getDoctorEfficiency: () =>
    fetchApi<{ doctors: DoctorEfficiencyRow[]; periodDays: number }>('/api/analytics/revenue/doctor-efficiency'),

  getLostRevenue: () =>
    fetchApi<LostRevenueResponse>('/api/analytics/revenue/lost-revenue'),

  getPatientCohort: () =>
    fetchApi<PatientCohortResponse>('/api/analytics/revenue/patient-cohort'),

  getOutstanding: () =>
    fetchApi<OutstandingResponse>('/api/analytics/revenue/outstanding'),

  getSuggestions: () =>
    fetchApi<{ suggestions: SuggestionFinding[] }>('/api/analytics/revenue/suggestions'),
};
